import { createAction } from "redux-actions";

import { moduleSlug } from "../../../constants";

export const requestFirsStep = createAction(`${moduleSlug}/REQUEST_FIRST_STEP`);

export const setOneStep = createAction(`${moduleSlug}/SET_ONE_STEP`);
export const mergeOneStep = createAction(`${moduleSlug}/MERGE_ONE_STEP`);
